import { useI18n } from "i18n";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { useStyles } from "./styles";

interface ErrorMessage {
  error: string;
  message: string;
}

interface Props {
  isFirebaseStorageAccessible: boolean;
}

export const FirewallDetectionError = ({
  isFirebaseStorageAccessible,
}: Props): JSX.Element | null => {
  const { t } = useI18n(["common", "micCamCheck"]);
  const classes = useStyles();

  const errors = [
    !isFirebaseStorageAccessible && {
      error: t("micCamCheck:storage.failure"),
      message: t("micCamCheck:storage.failure.message"),
    },
  ].filter(Boolean) as ErrorMessage[];

  return errors.length === 0 ? null : (
    <>
      {errors.map((error) => (
        <div className={classes.firewallErrorContainer} key={error.error}>
          <div>
            <Typography variant="subtitle1" className={classes.firewallError}>
              {error.error}
            </Typography>
          </div>
          <div>
            <Typography variant="subtitle1">{error.message}</Typography>
          </div>
        </div>
      ))}
    </>
  );
};
